import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=dfdbf862&"
import script from "./Plan.vue?vue&type=script&lang=js&"
export * from "./Plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureagent/_work/5/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfdbf862')) {
      api.createRecord('dfdbf862', component.options)
    } else {
      api.reload('dfdbf862', component.options)
    }
    module.hot.accept("./Plan.vue?vue&type=template&id=dfdbf862&", function () {
      api.rerender('dfdbf862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Account/Billing/Plan.vue"
export default component.exports